<template>
	<div>
		<el-dialog :visible.sync="showprintwin" title="重打" width="500px" :append-to-body="true"  :close-on-click-modal="false">
			<div class="printwin" style="height:220px;overflow-y:auto;margin-top:-20px" align="center">
				<table class="htmltable" style="width:100%">
					<tr>
						<td>
							<label style="color:blue;font-size:15pt;padding-left:15px">【打印顺序】是指模板输出的优先顺序</label>
							<pl-table :data="printmode" :style="{ width:`${tablewidth}px` }">
								<pl-table-column prop="e_modename" label="模板类型" min-width="50%"></pl-table-column>
								<pl-table-column prop="printenabeld" label="开启打印" width="80">
									<template slot-scope="scope">
										<el-switch v-model="scope.row.printenabeld" active-value="1" inactive-value="0" @change="checkedprint(scope.row)"></el-switch>
									</template>
								</pl-table-column>
								<pl-table-column prop="printindex" label="打印顺序" width="80">
									<template slot-scope="scope">{{scope.row.printindex}}</template>
								</pl-table-column>
							</pl-table>
						</td>
					</tr>
				</table>
			</div>
			 <span slot="footer" class="dialog-footer">
				 <div style="text-align: center;">
					 <el-button type="success" @click="SurePrint" size="mini">确 定</el-button>
					 <el-button @click="CancelPrint" size="mini">取 消</el-button>
				 </div>
			  </span>
		</el-dialog>
		<printhandler ref="printhandler"></printhandler>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
import printhandler from '@/components/order/printhandler.vue';
export default {
	components: {
		printhandler
	},
	data() {
		return {
			showprintwin:false,
			printmode:[{e_modename:'快递面单',printenabeld:'1',printindex:1},{e_modename:'官方面单',printenabeld:'0',printindex:''}],
			tablewidth:'530px',
			batch: '',
			pageparam: {},
			isorder: true, //是否顺序打印
			orderlist: [],
			divclass:'printwin',
			searchinfo:'',
			handtype:0,
			printset:[],
			//allorderlist:[]
		};
	},
	methods:{
		init(param) {
			this.$apipost.get.getTheme().then(res => {
				import('../../static/' + res + '/style/logisticsmanager/printhandler.scss');
			});
			var that = this;
			
			that.searchinfo = param.searchinfo;
			that.pageparam = param.pageparam;
			//that.batch = param.batch;
			//that.orderinfo = param.orderinfo;
			//that.orderlist = param.orderlist;
			that.printmode=[{e_modename:'快递面单',printenabeld:'1',printindex:1},{e_modename:'官方面单',printenabeld:'0',printindex:''}];
	
			that.handtype = param.handtype;
			this.$tool.loadingclose();
			this.GetPrintOrder();
		},
		//开启打印
		checkedprint(row) {
			var that = this;
			if(row.printenabeld=='1')
			{
				if(row.e_modename=='快递面单'){
					if(this.printmode[0].printindex!='')
						row.printindex='2';
					else
						row.printindex='1';
				}else{
					if(this.printmode[0].printindex!='')
						row.printindex='2';
					else
						row.printindex='1';
				}
			}
			else{
				row.printindex='';
				if(row.e_modename=='快递面单'){
					if(this.printmode[1].printindex!='')
						row.printindex='2';
				}else{
					if(this.printmode[1].printindex!='')
						row.printindex='1';
				}
			}
		},
		//获取权限内的打印模板
		GetPrintOrder() {
			var that = this;
			this.$tool.loading('正在获取订单', that.pageparam.divclass);
			this.$apipost.post.InsertTemp({ l_mode: that.pageparam.mode, tab: that.pageparam.tabs[that.pageparam.activeTabIndex].type, search: that.searchinfo, sort: that.pageparam.sort }).then(res => {
				debugger
				this.$tool.loadingclose();
				if (res != '') {
					if (res.batch != '') {
						that.GetOrderList(res.batch);
					} else {
						this.$tool.message('获取数据失败', 0);
					}
				} else {
					this.$tool.message('获取数据失败', 0);
				}
			});
		},
		GetOrderList(batch){
			var that=this;
			var paraminfo={
				batch:batch
			}
			this.$apipost.get.GetPrintOrderList({ paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					that.orderlist=res.orderlist;
					that.showprintwin=true;
					//that.allorderlist=JSON.parse(JSON.stringify(res.orderlist));
					that.gf=res.gf;
					if(that.gf.length==0)
						that.printmode=[{e_modename:'快递面单',printenabeld:'1',printindex:1}];
				} else {
					this.$tool.message('无订单可操作', 0);
				}
			});
		},
		SurePrint(){
			var that=this;
			var isgf=false;
			var list=JSON.parse(JSON.stringify(this.orderlist));
			if(list.length>0){
				this.printmode.forEach(e=>{
					if(e.printenabeld=='0'&&e.e_modename=='快递面单')
					{
						list.forEach(b=>{
							e.e_code='';
							e.e_modename='';
						});
					}
					else if(e.printenabeld=='1'&&e.e_modename=='官方面单')
						isgf=true;
				});
				if(this.$refs.printhandler!=undefined){
					this.$refs.printhandler._data.handtype=this.handtype;
					this.$refs.printhandler._data.diskpath='';
					this.$refs.printhandler._data.pageparam=this._data;
					if(!isgf)
						this.$refs.printhandler.ForPrint(list,0);
					else
						this.$refs.printhandler.ForPrint(list,0,this.gf[0]);
				}else{
					this.$tool.message('预览组件未加载，请关闭窗口重试', 0);
				}
			}
		},
		CancelPrint(){
			this.showprintwin = false;
		}
	}
}
</script>

<style>
</style>
